/**
 * @generated SignedSource<<1141377722825598a18a8a7d75c5b4df>>
 * @relayHash aae0b2e79c40fd5e3f91557622298c6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f0675a4c080aae13f3e048f743c8a13986f4ab80c458e624f0b061895f10e740

import type { ConcreteRequest } from 'relay-runtime';
export type IssueUpdateSuggestionsSubscription$variables = {
  cloudId: string;
  projectAri: string;
};
export type IssueUpdateSuggestionsSubscription$data = {
  readonly jira_onIssueUpdateSuggestions: {
    readonly rovo: {
      readonly actionMessageId: string | null;
      readonly channelConversationId: string;
    } | null;
    readonly sourceAri: string;
    readonly suggestions: {
      readonly fieldsCount: number | null;
      readonly issuesCount: number | null;
    } | null;
    readonly targetAri: string;
    readonly userAri: string;
  } | null;
};
export type IssueUpdateSuggestionsSubscription = {
  response: IssueUpdateSuggestionsSubscription$data;
  variables: IssueUpdateSuggestionsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "projectAri",
        "variableName": "projectAri"
      }
    ],
    "concreteType": "JiraIssueUpdatesSuggestion",
    "kind": "LinkedField",
    "name": "jira_onIssueUpdateSuggestions",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "userAri"
      },
      {
        "kind": "ScalarField",
        "name": "sourceAri"
      },
      {
        "kind": "ScalarField",
        "name": "targetAri"
      },
      {
        "concreteType": "JiraRovoConversationMetadata",
        "kind": "LinkedField",
        "name": "rovo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "channelConversationId"
          },
          {
            "kind": "ScalarField",
            "name": "actionMessageId"
          }
        ]
      },
      {
        "concreteType": "JiraIssueUpdatesSuggestionMetadata",
        "kind": "LinkedField",
        "name": "suggestions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "issuesCount"
          },
          {
            "kind": "ScalarField",
            "name": "fieldsCount"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueUpdateSuggestionsSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueUpdateSuggestionsSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f0675a4c080aae13f3e048f743c8a13986f4ab80c458e624f0b061895f10e740",
    "metadata": {},
    "name": "IssueUpdateSuggestionsSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "6e02c936e50cad924c6ba9c62597bba4";

export default node;
